import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, formValueSelector, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import SidePanel from './SidePanel';
import FooterButton from './FooterButton';

// Locale
import messages from '../../locale/jsonMessages';
import validateStep3 from './validateStep3';
import updateStep3 from './updateStep3';

//images
import infoIcon from '/public/SiteIcons/priceHoverIcon.svg';
import locationIcon from '/public/SiteIcons/locationIdea.svg';
import CommonFormComponent from '../CommonField/CommonFormComponent';
import { normalizePrice } from '../EditProfileForm/normalizePhone';

import AskAIButton from '../Common/AskAIButton/AskAIButton';
import { openAIModal } from '../../actions/modalActions';
import CommonModal from '../CommonModal/CommonModal';
import getCarPricing from '../AIFeatures/Helper/getCarPricing';
import { isOwnerAIFeatureStatus } from '../../helpers/aiFeatureStatusHelper';
import { getLocation, getSelectedCarFeatures, getSelectedMakeAndModal } from '../AIFeatures/Helper/getListingData';
import cs from '../commonStyle.css';
import s from './ListPlaceStep1.css';


class Pricing extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
    };
  }

  componentDidMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid } = nextProps;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  handleOpenAIModal = async () => {

    const { openAIModal } = this.props;
    const { formValues, currency, listingFields, dispatch } = this.props;

    const location = getLocation(formValues);
    const carFeatures = await getSelectedCarFeatures(
      formValues?.userAmenities,
      formValues?.carFeatures,
      formValues?.settingsData
    );

    const getMake = await getSelectedMakeAndModal(formValues?.make, listingFields?.make);
    const getModel = await getSelectedMakeAndModal(formValues?.model, listingFields?.model);
    const getCarType = await getSelectedMakeAndModal(formValues?.carType, listingFields?.carType);
    const year = await getSelectedMakeAndModal(formValues?.year, listingFields?.year);

    await getCarPricing({
      location,
      carFeatures,
      make: getMake,
      model: getModel,
      carType: getCarType,
      year,
      currency,
      openAIModal,
      dispatch
    })

  }

  render() {
    const { handleSubmit, nextPage, previousPage, formPage, step, availableCurrencies, siteSettingStatus } = this.props;
    const { ownerServicePlanAIFeatureStatus, aiAccessCarMarketPricing, aiOwnerAccess, isAIFeatureEnabled } = this.props;
    const { formatMessage } = this.props.intl;
    const { isDisabled } = this.state;

    let isSecurityPreference = siteSettingStatus?.securityDepositPreference == 2 ? false : true;
    let isOwnerAIPricingStatus = isOwnerAIFeatureStatus({
      isOwnerAIEnabled: aiAccessCarMarketPricing,
      isGlobalAIEnabled: isAIFeatureEnabled,
      hasActiveServicePlan: ownerServicePlanAIFeatureStatus,
      servicePlanUsers: aiOwnerAccess
    })

    return (
      <div className={cx(s.stepGrid, 'stepGridRTL')}>
        <SidePanel
          title={formatMessage(messages.step3Heading)}
          landingContent={formatMessage(messages.setPricingText)}
        />
        <CommonModal
          title={formatMessage(messages.checkMarketPrice)}
          formName="CarPricingWithAI"
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <div className="oneColumnGrid">
              <Field name="currency"
                component={CommonFormComponent}
                labelText={<FormattedMessage {...messages.currency} />}
                inputClass='commonSelectField'
              >
                {
                  availableCurrencies.map((currency, key) => {
                    if (currency.isEnable === true) {
                      return <option key={key} value={currency.symbol}>{currency.symbol}</option>
                    }
                  })
                }
              </Field>

              <div>
                <Field
                  name="basePrice"
                  type="text"
                  component={CommonFormComponent}
                  placeholder={formatMessage(messages.basePriceLabel)}
                  labelText={<FormattedMessage {...messages.basePrice} />}
                  toolTipText={formatMessage(messages.basePriceInfo)}
                  inputClass='commonInputField'
                  normalize={normalizePrice}
                  isRequiredInput
                  note={
                    <div>
                      <img src={locationIcon} className={cx(cs.positionRelative, cs.topMinus3)} />&nbsp;
                      <span className={cx(s.locationTipCss, cs.commonMediumText)}><FormattedMessage {...messages.pricingDescription} /></span>
                    </div>
                  }
                />

                <AskAIButton
                  containerClass={cs.spaceTop2}
                  btnText={formatMessage(messages.checkMarketPrice)}
                  onClick={this.handleOpenAIModal}
                  buttonType={'loader'}
                  isButtonVisible={isOwnerAIPricingStatus}
                />
              </div>

              <Field
                name="delivery"
                type="text"
                component={CommonFormComponent}
                placeholder={formatMessage(messages.delivery)}
                labelText={<FormattedMessage {...messages.delivery} />}
                toolTipText={formatMessage(messages.deliveryInfo)}
                inputClass='commonInputField'
                normalize={normalizePrice}
              />

              {
                isSecurityPreference &&
                <Field
                  name="securityDeposit"
                  type="text"
                  component={CommonFormComponent}
                  placeholder={formatMessage(messages.securityDeposit)}
                  labelText={<FormattedMessage {...messages.securityDeposit} />}
                  toolTipText={formatMessage(messages.infoContent)}
                  inputClass='commonInputField'
                  normalize={normalizePrice}
                />
              }
            </div>
          </div>
          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            previousPagePath={"car-rules"}
            nextPagePath={"discount"}
            formPage={formPage}
            step={step}
            isDisabled={isDisabled}
          />
        </form>
      </div>
    );
  }
}

Pricing = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(Pricing);

const selector = formValueSelector('ListPlaceStep3');

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  availableCurrencies: state.currency.availableCurrencies,
  aiAccessCarMarketPricing: state?.siteSettings?.data?.aiAccessCarMarketPricing,
  isAIFeatureEnabled: state.siteSettings.data?.aiTextGeneration,
  ownerServicePlanAIFeatureStatus: state?.account?.data?.ownerServicePlanAIFeatureStatus,
  aiOwnerAccess: state?.siteSettings?.data?.aiOwnerAccess,
  siteSettingStatus: state.siteSettings.data,
  currency: selector(state, 'currency'),
  formValues: getFormValues('ListPlaceStep1')(state) || {},
});

const mapDispatch = {
  openAIModal
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(Pricing)));
